import React from 'react';
import { benefits } from '../mock';
import { Button } from './ui/button';
import { Calendar } from 'lucide-react';

const Benefits = ({ onBookingClick }) => {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black border-2 border-gold rounded-3xl mb-8">
      <div className="container mx-auto">
        <h2 className="text-xl sm:text-[3.2vw] md:text-[3vw] lg:text-[2.85vw] text-center mb-16 text-gold font-semibold sm:whitespace-nowrap" style={{ textTransform: 'none', fontFamily: 'Montserrat, sans-serif' }}>
          Why Choose "Elvis - One More Time?"
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.id}
              className={`group relative p-8 bg-black rounded-xl border-2 transition-all duration-300 hover:gold-glow-strong text-center ${
                index % 4 === 0 ? 'border-gold/30 hover:border-gold' :
                index % 4 === 1 ? 'border-cyan/30 hover:border-cyan cyan-glow' :
                index % 4 === 2 ? 'border-red/30 hover:border-red red-glow' :
                'border-silver/30 hover:border-silver silver-glow'
              } ${index === benefits.length - 1 ? 'lg:col-start-2' : ''}`}
            >
              <h3 className={`text-xl mb-3 font-semibold ${
                index % 4 === 0 ? 'text-gold' :
                index % 4 === 1 ? 'text-cyan' :
                index % 4 === 2 ? 'text-red' :
                'text-silver'
              }`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {benefit.title}
              </h3>
              <p className="text-white/80 leading-relaxed">
                {benefit.description}
              </p>
              
              {/* Inner glow effect */}
              <div className={`absolute inset-0 rounded-xl bg-gradient-to-br opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${
                index % 4 === 0 ? 'from-gold/5' :
                index % 4 === 1 ? 'from-cyan/5' :
                index % 4 === 2 ? 'from-red/5' :
                'from-silver/5'
              } to-transparent`}></div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-12 text-center">
          <Button
            onClick={onBookingClick}
            className="bg-gold text-black hover:bg-gold/90 font-semibold px-8 py-6 text-lg rounded-lg transition-all duration-300 shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] hover:scale-105"
            data-testid="benefits-cta-btn"
          >
            <Calendar className="mr-2" size={20} />
            Check Availability & Book
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
